import {
  EXPORT_TYPE,
  IExportChatFields,
  IGroupInfo,
} from "@home-health-notify/domain";
import ChatBubbleOutlinedIcon from "@mui/icons-material/ChatBubbleOutlined";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import {
  ApiErrorHandler,
  OrganizationContext,
  useTranslation,
} from "hhn-commons";
import { useSnackbar } from "notistack";
import { useContext, useState } from "react";

export const ExportSettings = ({ groupInfo }: { groupInfo: IGroupInfo }) => {
  const { t } = useTranslation();
  const tNs1 = (key: string) => t(key, { ns: "groupChatInfo" });
  const tNs2 = (key: string) => t(key, { ns: "exportChat" });
  const { selectedOrgUser } = useContext(OrganizationContext);
  const { enqueueSnackbar } = useSnackbar();
  const [isExportingChat, setIsExportingChat] = useState(false);
  const [isExportingMedia, setIsExportingMedia] = useState(false);

  const downloadChat = async (id: string) => {
    setIsExportingChat(true);
    try {
      let exportChatData: IExportChatFields = {
        chatId: id,
        exportType: EXPORT_TYPE.CHAT,
      };

      await selectedOrgUser?.exportChat.initiateExport(exportChatData, false);
      enqueueSnackbar(tNs2("success"));
    } catch (e) {
      ApiErrorHandler(e, enqueueSnackbar, tNs2("exportChatError"));
    } finally {
      setIsExportingChat(false);
    }
  };

  const downloadMedia = async (id: string) => {
    setIsExportingMedia(true);
    try {
      let exportChatData: IExportChatFields = {
        chatId: id,
        exportType: EXPORT_TYPE.MEDIA,
      };

      await selectedOrgUser?.exportChat.initiateExport(exportChatData, false);
      enqueueSnackbar(tNs2("success"));
    } catch (e) {
      ApiErrorHandler(e, enqueueSnackbar, tNs2("exportMediaError"));
    } finally {
      setIsExportingMedia(false);
    }
  };

  return (
    <Box sx={{ padding: "20px" }}>
      <Typography sx={{ marginBottom: "20px" }}>
        {tNs1("exportSettings")}
      </Typography>
      <Tooltip title={tNs2("exportChat")}>
        <span>
          <IconButton
            disabled={isExportingChat}
            onClick={() => downloadChat(groupInfo.id)}
            data-testid="export-chat-settings"
          >
            <ChatBubbleOutlinedIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={tNs2("exportMedia")}>
        <span>
          <IconButton
            sx={{ marginRight: "10px" }}
            disabled={isExportingMedia}
            onClick={() => downloadMedia(groupInfo.id)}
            data-testid="export-media-settings"
          >
            <WallpaperIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};
